module.exports = __webpack_public_path__ + "img/book.4284412a.svg";